import FiltersRange from './filtersRange'

export default FiltersRange
